// product list
export const FETCH_SUMMERY_REQUEST = 'CATEGORY_POST_REQUEST';
export const FETCH_SUMMERY_SUCCESS = 'FETCH_SUMMERY_SUCCESS';
export const FETCH_SUMMERY_ERROR = 'FETCH_SUMMERY_ERROR'; 

